import { createAuthClient } from 'better-auth/client'
import { organizationClient } from 'better-auth/client/plugins'
import { adminClient } from 'better-auth/client/plugins'
import { resolveApiBaseUrl } from './resolve-api-url'

export const authClient = createAuthClient({
  baseURL: resolveApiBaseUrl(),
  basePath: '/api/auth',
  plugins: [organizationClient(), adminClient()],
})
